/**
 * Audit Log Action Types
 *
 * Single source of truth for all audit action strings.
 * Import these constants instead of using string literals.
 */

export const AUDIT_ACTIONS = {
  // Canvas operations
  MOVE: 'move',
  RESIZE: 'resize',
  RENAME: 'rename',
  ADD: 'add',
  DELETE: 'delete',

  // Assignment operations
  ASSIGN: 'assign',
  UNASSIGN: 'unassign',

  // Hold
  HOLD: 'hold',
  UNHOLD: 'unhold',

  // Pricing
  PRICE_ASSIGN: 'price_assign',
  PRICE_UNASSIGN: 'price_unassign',
  PRICE_UPDATE: 'price_update',

  // Booth grouping
  COMBINE: 'combine',
  UNCOMBINE: 'uncombine',
  UNDELETE: 'undelete',

  // Purchasing
  BUY: 'buy',

  // Background
  SET_BACKGROUND: 'set_background',
  DELETE_BACKGROUND: 'delete_background',

  // Map-level (these bypass Redux, saved directly)
  IMPORT_DWG: 'import dwg',
  DELETE_DWG: 'delete_dwg',
};

Object.freeze(AUDIT_ACTIONS);
